import React from 'react';
import { Button, Tag } from 'antd';
import { InboxFileRow, InboxFilters } from '../../../types/index';
import { getInboxFileStatus } from '../../../lib/util/status';
import moment from 'moment';
import { Icon } from '@ant-design/compatible';
import { CustomLink } from '../../../components/CustomLink';
import { DateFilter, FlowFilter, NameFilter, ScoreFilter, StatusFilter, TagFilter } from '../Filters';
import { Shorten } from '../../../components/text/Shorten';

export const GetInboxsetOverviewTableColumns = (
  onClickUrl: (inboxFile: InboxFileRow) => any,
  onDelete: (inboxFile: InboxFileRow) => any,
  toggleFileStatus: (inboxFile: InboxFileRow) => any,
  filters: InboxFilters,
  setFilters: (filters: any) => any,
  flowOptions: any
) => {
  return [
    {
      title: 'Name',
      key: 'reference_run_id',
      dataIndex: 'reference_run_id',
      sorter: {
        multiple: 1,
      },
      filterDropdown: () => <NameFilter filters={filters} setFilters={setFilters} />,
      filterIcon: () => <Icon style={{ color: filters.name ? '#1890ff' : undefined }} theme="filled" type="filter" />,
      render: (text: string, inboxFile: InboxFileRow) => (
        <div style={{ width: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <CustomLink
            style={{
              width: 'inherit',
              textAlign: 'left',
            }}
            onClickUrl={onClickUrl(inboxFile)}
            disabled={inboxFile.inbox_status === 'PROCESSING'}>
            <span style={{ width: 'inherit', overflow: 'hidden', whiteSpace: 'nowrap' }}>
              {inboxFile.inbox_reference_run_id}
            </span>
          </CustomLink>
        </div>
      ),
    },
    {
      title: 'Date',
      key: 'time_created',
      dataIndex: 'time_created',
      filterDropdown: () => <DateFilter filters={filters} setFilters={setFilters} />,
      filterIcon: () => (
        <Icon style={{ color: filters.date.length ? '#1890ff' : undefined }} theme="filled" type="filter" />
      ),
      sorter: {
        multiple: 1,
      },
      render: (text: string, inboxFile: InboxFileRow) => (
        <span>{moment(inboxFile.inbox_time_created).format('ll HH:mm:ss')}</span>
      ),
    },
    {
      title: 'Tag',
      key: 'tag',
      dataIndex: 'tag',
      filterIcon: () => <Icon style={{ color: filters.tag ? '#1890ff' : undefined }} theme="filled" type="filter" />,
      filterDropdown: () => <TagFilter filters={filters} setFilters={setFilters} />,
      sorter: {
        multiple: 1,
      },
      render: (text: string, inboxFile: InboxFileRow) => {
        const tag = inboxFile.inbox_tag || 'Unlabelled';
        return (
          <span>
            <Tag>
              <Shorten text={tag} digits={16} />
            </Tag>
          </span>
        );
      },
    },
    {
      title: 'Tag Count',
      key: 'tag_count',
      dataIndex: 'tag_count',
      sorter: {
        multiple: 1,
      },
      render: (text: string, inboxFile: InboxFileRow) => <span>{inboxFile.inbox_tag_count}</span>,
    },
    {
      title: 'Flow',
      key: 'flow',
      dataIndex: 'flow',
      filterIcon: () => (
        <Icon style={{ color: filters.flow.length ? '#1890ff' : undefined }} theme="filled" type="filter" />
      ),
      filterDropdown: () => <FlowFilter filters={filters} setFilters={setFilters} flowOptions={flowOptions} />,
      render: (text: string, inboxFile: InboxFileRow) => <span>{inboxFile.inbox_multiflow_name}</span>,
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      filterIcon: () => <Icon style={{ color: filters.status ? '#1890ff' : undefined }} theme="filled" type="filter" />,
      filterDropdown: () => <StatusFilter filters={filters} setFilters={setFilters} />,
      render: (text: string, inboxFile: InboxFileRow) => {
        return (
          <span>
            <Tag
              style={{ cursor: 'pointer' }}
              onClick={() => toggleFileStatus(inboxFile)}
              color={getInboxFileStatus(inboxFile).color}>
              {getInboxFileStatus(inboxFile).label}
            </Tag>
          </span>
        );
      },
    },
    {
      title: 'Score',
      key: 'score',
      dataIndex: 'score',
      filterIcon: () => (
        <Icon style={{ color: filters.score.length ? '#1890ff' : undefined }} theme="filled" type="filter" />
      ),
      filterDropdown: () => <ScoreFilter filters={filters} setFilters={setFilters} />,
      sorter: { multiple: 1 },
      render: (text: string, inboxFile: InboxFileRow) => (
        <span>{((inboxFile.inbox_score || 0) * 100).toFixed(0)}%</span>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text: string, record: InboxFileRow) => (
        <span>
          <Button type="link" onClick={() => onDelete(record)} style={{ marginLeft: '20px' }}>
            Delete
          </Button>
        </span>
      ),
    },
  ];
};
